<div class="filter-options-container">
  <mat-radio-group [formControl]="optionSelected">
    <mat-radio-button
      [disableRipple]="true"
      *ngFor="let option of options"
      [value]="option.value">
      {{ option.label }}
    </mat-radio-button>
  </mat-radio-group>
</div>
